import { DefaultText } from 'components/_universal/Typography.styled';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const FooterWrapper = styled.div(
    ({ theme: { gradients } }) => css`
        align-items: center;
        background: ${gradients.primary};
        display: flex;
        height: 80px;
        justify-content: space-between;
        left: 0;
        padding: 14px 82px;
        position: fixed;
        right: 0;
        bottom: 0;
        z-index: 99;
    `,
);
export const FooterLink = styled(Link)(
    ({ theme: { fontFamily, colors, fontSizes, fontWeight } }) => css`
        color: ${colors.white};
        font-family: ${fontFamily.secondary};
        font-size: ${fontSizes.f14};
        font-weight: ${fontWeight.medium};
        text-decoration: none;
        text-transform: uppercase;
    `,
);

export const FooterText = styled(DefaultText)(
    ({ theme: { fontFamily, colors, fontSizes, fontWeight } }) => css`
        color: ${colors.white};
        font-family: ${fontFamily.secondary};
        font-size: ${fontSizes.f14};
        font-weight: ${fontWeight.medium};
        text-decoration: none;
        text-transform: uppercase;
    `,
);
